module.exports = __webpack_public_path__ + "static/img/preview-05.4f45a757.webp";